module.exports = __webpack_public_path__ + "img/Piece-18-Inspect-Small.d3f08117.png";